import React from 'react'
import Card from 'react-bootstrap/Card';
import './Carousel_cult.css'
import img from './photos/sld9.jpg'
import img1 from './photos/sld10.jpg'
import img2 from './photos/sld11.jpg'
import img3 from './photos/sld12.jpg'
function Carousel_cult2() {
  return (
    <div className='carousel_div'>
       <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img}/>
        <h1>CONTEMPORARY GALLERY</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img1}/>
        <h1>SELECTIVE COLLECTIONS</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img2}/>
        <h1>ART GALLERY</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img3}/>
        <h1>VILLAGE HIUN, SHIMLA</h1>
      </Card.Body>
    </Card>
    </div>
  )
}

export default Carousel_cult2
